// Instance
import MainAPI from "@/app/apis/main/main-api.js"

// Endpoints
import { API, ENDPOINTS } from "@/app/apis/main/_connection/connection-api.js"

// Query String
const queryString = require("querystring")

class puppySellApi extends MainAPI {
	/**
	 * @return {object} list of Puppy to sell
	 * @params queryParams
	 * */
	async getPuppySellList(queryParams) {
		return API.get(`${ENDPOINTS.GET_PUPPY_SELL}/request/list?${queryString.stringify(queryParams)}`)
	}

	async getPuppySellPaymentList(queryParams) {
		return API.get(`admin${ENDPOINTS.GET_PUPPY_SELL}/payment/list?${queryString.stringify(queryParams)}`)
	}
	
	async getPuppyPaymentDetails(puppySellId) {
		return API.get(`admin${ENDPOINTS.GET_PUPPY_SELL}/${puppySellId}/payment`)
	}

	async getPuppyDetailsById(puppySellId) {
		return API.get(`${ENDPOINTS.GET_PUPPY_SELL}/${[puppySellId]}`)
	}

	async puppySellApprovedDeclined(details) {
		return API.put(`${ENDPOINTS.PUT_PUPPY_SELL}/approved-disapproved`, details)
	}

	async getPendingPuppySellCount() {
		return API.get(`${ENDPOINTS.GET_PUPPY_SELL}/pending/count`)
	}

	/**
	 * @return Get the number of Pending Request
	 * @param {Object} details { status, puppyToSellId, paymentMethod, remarks }
	 * */

	async putPuppyPurchaseRefundApproval(details) {
		return API.put(`${ENDPOINTS.PUT_PUPPY_SELL}/approved-disapproved-refund`, details)
	}

	/**
	 * @param {Object} details { puppySellId, details }
	 * */
	async updatePuppyDetailsStatus(puppySellId, details) {
		return API.put(`${ENDPOINTS.PUT_PUPPY_SELL}/status/update/${puppySellId}`, details)
	}
    
	/**
	 * @param {Object} details { puppySellId, details }
	 * */
	async updatePuppyDetailsStatusById(puppySellId, details) {
		return API.put(`/admin${ENDPOINTS.PUT_PUPPY_SELL}/status/update/${puppySellId}`, details)
	}

	/**
	 * @param {Object} puppyDetails { puppyDetails }
	 * */
	async updatePuppyDetails(puppyDetails) {
		let newFormData = new FormData()
		newFormData.append("formData", JSON.stringify(puppyDetails.formData))

		if (puppyDetails.images.length > 0) {
			puppyDetails.images.forEach((image) => {
				newFormData.append("images", image)
			})
		}

		return API.put(`${ENDPOINTS.PUT_PUPPY_SELL}/details/update`, newFormData)
	}

	async putDeletePuppyToSell(puppySellId) {
		return API.put(`${ENDPOINTS.PUT_PUPPY_SELL}/delete/${puppySellId}`)
	}


	async putPuppyPurchaseBalance(puppySellId, details) {
		return API.put(`admin${ENDPOINTS.PUT_PUPPY_SELL}/update/balance/${puppySellId}`, details)
	}
}

export default new puppySellApi()
